/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD';
export const ON_SUBMIT_TRUE = 'boilerplate/UploadPageB2C/ON_SUBMIT_TRUE';
export const SET_PROCESS_COUNT = 'boilerplate/UploadPageB2C/SET_PROCESS_COUNT';
export const SET_ERR_COUNT = 'boilderplate/UploadPageB2C/SET_ERR_COUNT'
export const PROFILE_INFO = 'boilerplate/UploadPageB2C/PROFILE_INFO'
export const LOADER_STATUS = 'boilderplate/UploadPageB2C/LOADER_STATUS'
export const SET_ERROR = 'boilerplate/UploadPageB2C/SET_ERROR'
export const SET_UPLOAD_MSG = 'boilerplate/UploadPageB2C/SET_UPLOAD_MSG'
export const ON_PROGRESS_DATA = 'boilderplate/UploadPageB2C/ON_PROGRESS_DATA'
export const ON_NOTIFY = 'boilerplate/UploadPageB2C/ON_NOTIFY'